export const airlineG9 = ["Air Arabia", "G9"];
export const airlineKC = ["Air Astana", "KC"];
export const airlineUU = ["Air Austral", "UU"];
export const airlineBT = ["Air Baltic", "BT"];
export const airlineBP = ["Air Botswana", "BP"];
export const airline2J = ["Air Burkina", "2J"];
export const airlineSM = ["Air Cairo", "SM"];
export const airlineTY = ["Air Caledonie", "TY"];
export const airlineAC = ["Air Canada", "AC"];
export const airlineTX = ["Air Caraibes", "TX"];
export const airlineGB = ["ABX Air", "GB"];
export const airlineEI = ["Aer Lingus", "EI"];
export const airlineP5 = ["Aero Republica", "P5"];
export const airlineSU = ["Aeroflot", "SU"];
export const airlineAR = ["Aerolineas Argentinas", "AR"];
export const airlineVW = ["Aeromar", "VW"];
export const airlineAM = ["Aeromexico", "AM"];
export const airlineAW = ["Africa World Airlines", "AW"];
export const airlineAH = ["Air Algérie", "AH"];
export const airlineKM = ["Air Malta ", "KM"];
export const airlineMK = ["Air Mauritius", "MK"];
export const airline9U = ["Air Moldova", "9U"];
export const airlineNZ = ["Air New Zealand", "NZ"];
export const airlinePX = ["Air Niugini", "PX"];
export const airlineYW = ["Air Nostrum", "YW"];
export const airlineP4 = ["Air Peace", "P4"];
export const airlineJU = ["Air Serbia", "JU"];
export const airlineHM = ["Air Seychelles", "HM"];
export const airlineVT = ["Air Tahiti", "VT"];
export const airlineTN = ["Air Tahiti Nui", "TN"];
export const airlineTC = ["Air Tanzania", "TC"];
export const airlineTS = ["Air Transat", "TS"];
export const airlineNF = ["Air Vanuatu", "NF"];
export const airlineRU = ["AirBridgeCargo Airlines", "RU"];
export const airlineSB = ["Aircali", "SB"];
export const airline4Z = ["Airlink", "4Z"];
export const airlineAS = ["Alaska Airlines", "AS"];
export const airlineAP = ["Albastar", "AP"];
export const airline4W = ["Allied Air", "4W"];
export const airlineUJ = ["AlMasria Universal Airlines", "UJ"];
export const airlineAA = ["American Airlines", "AA"];
export const airlineNH = ["ANA ", "NH"];
export const airlineGP = ["APG Airlines", "GP"];
export const airlineIZ = ["Arkia Israeli Airlines ", "IZ"];
export const airlineOZ = ["Asiana Airlines", "OZ"];
export const airlineKP = ["ASKY", "KP"];
export const airline5O = ["ASL Airlines France", "5O"];
export const airlineRC = ["Atlantic Airways", "RC"];
export const airline5Y = ["Atlas Air", "5Y"];
export const airlineOS = ["Austria", "OS"];
export const airlineAV = ["Avianca", "AV"];
export const airlineLR = ["Avianca Costa Rica", "LR"];
export const airline2K = ["Avianca Ecuador", "2K"];
export const airlineJ2 = ["Azerbaijan Airlines", "J2"];
export const airlineS4 = ["Azores Airlines", "S4"];
export const airlineAD = ["Azul Brazilian Airlines", "AD"];
export const airlineJ4 = ["Badr Airlines", "J4"];
export const airlineUP = ["Bahamasair", "UP"];
export const airlineQH = ["Bamboo Airways", "QH"];
export const airlinePG = ["Bangkok Airways ", "PG"];
export const airlineID = ["Batik Air", "ID"];
export const airlineOD = ["Batik Air Malaysia", "OD"];
export const airlineB2 = ["Belavia Belarusian Airlines", "B2"];
export const airlineBG = ["Biman Bangladesh Airlines", "BG"];
export const airlineNT = ["Binter Canarias", "NT"];
export const airline0B = ["Blue Air", "0B"];
export const airlineOB = ["BoA Boliviana de Aviacion ", "OB"];
export const airlineTF = ["Braathens Regional Airways ", "TF"];
export const airlineBA = ["British Airways", "BA"];
export const airlineSN = ["Brussels Airlines", "SN"];
export const airlineFB = ["Bulgaria Air", "FB"];
export const airlineVR = ["Cabo Verde Airlines", "VR"];
export const airline5C = ["CAL Cargo Airlines", "5C"];
export const airlineQC = ["CamairCo", "QC"];
export const airlineK6 = ["Cambodia Angkor Air", "K6"];
export const airlineJD = ["Capital Airlines", "JD"];
export const airlineW8 = ["Cargojet Airways ", "W8"];
export const airlineCV = ["Cargolux ", "CV"];
export const airlineBW = ["Caribbean Airlines", "BW"];
export const airlineV3 = ["Carpatair", "V3"];
export const airlineCX = ["Cathay Pacific", "CX"];
export const airline5J = ["Cebu Pacific", "5J"];
export const airlineCI = ["China Airlines", "CI"];
export const airlineCK = ["China Cargo Airlines ", "CK"];
export const airlineMU = ["China Easter", "MU"];
export const airlineG5 = ["China Express Airlines", "G5"];
export const airlineCF = ["China Postal Airlines", "CF"];
export const airlineCZ = ["China Southern Airlines", "CZ"];
export const airlineWX = ["CityJet", "WX"];
export const airlineDE = ["Condor", "DE"];
export const airline8Z = ["Congo Airways", "8Z"];
export const airlineCM = ["COPA Airlines", "CM"];
export const airlineXC = ["Corendon Airlines", "XC"];
export const airlineSS = ["Corsair International", "SS"];
export const airlineOU = ["Croatia Airlines", "OU"];
export const airlineCU = ["Cubana", "CU"];
export const airlineCY = ["Cyprus Airways", "CY"];
export const airlineOK = ["Czech Airlines ", "OK"];
export const airlineDL = ["Delta Air Lines", "DL"];
export const airlineD0 = ["DHL Air ", "D0"];
export const airlineES = ["DHL Aviation ", "ES"];
export const airline2D = ["Eastern Airlines", "2D"];
export const airlineT3 = ["Eastern Airways", "T3"];
export const airlineMS = ["Egyptair", "MS"];
export const airlineLY = ["EL AL", "LY"];
export const airlineEK = ["Emirates", "EK"];
export const airlineET = ["Ethiopian Airlines", "ET"];
export const airlineEY = ["Etihad Airways", "EY"];
export const airlineYU = ["EuroAtlantic Airways", "YU"];
export const airlineQY = ["European Air Transport", "QY"];
export const airlineEW = ["Eurowings", "EW"];
export const airlineBR = ["EVA Air", "BR"];
export const airlineE9 = ["Evelop Airlines", "E9"];
export const airlineFX = ["FedEx Express", "FX"];
export const airlineFJ = ["Fiji Airways", "FJ"];
export const airlineAY = ["Fiair", "AY"];
export const airlineIF = ["Fly Baghdad ", "IF"];
export const airlineFZ = ["flydubai", "FZ"];
export const airlineFT = ["FlyEgypt", "FT"];
export const airlineXY = ["Flynas", "XY"];
export const airline5F = ["FLYONE", "5F"];
export const airlineFH = ["Freebird Airlines", "FH"];
export const airlineBF = ["French Bee", "BF"];
export const airlineFU = ["Fuzhou Airlines", "FU"];
export const airlineGA = ["Garuda Indonesia", "GA"];
export const airlineA9 = ["Georgian Airways", "A9"];
export const airlineZQ = ["German Airways", "ZQ"];
export const airlineG3 = ["GOL Linhas Aereas", "G3"];
export const airlineGF = ["Gulf Air", "GF"];
export const airlineGX = ["GX Airlines", "GX"];
export const airlineHR = ["Hahn Air", "HR"];
export const airlineHU = ["Hainan Airlines", "HU"];
export const airlineHA = ["Hawaiian Airlines", "HA"];
export const airlineNS = ["Hebei Airlines", "NS"];
export const airline5K = ["Hi Fly", "5K"];
export const airlineRH = ["Hong Kong Air Cargo ", "RH"];
export const airlineHX = ["Hong Kong Airlines", "HX"];
export const airlineUO = ["Hong Kong Express Airways ", "UO"];
export const airlineIB = ["IBERIA", "IB"];
export const airlineFI = ["Icelandair", "FI"];
export const airline6E = ["IndiGo", "6E"];
export const airlineIR = ["Iran Air", "IR"];
export const airlineB9 = ["Iran Airtour Airline", "B9"];
export const airlineEP = ["Iran Aseman Airlines", "EP"];
export const airline6H = ["Israir", "6H"];
export const airlineAZ = ["ITA Airways", "AZ"];
export const airlineJL = ["Japan Airlines", "JL"];
export const airlineNU = ["Japan Transocean Air", "NU"];
export const airlineJ9 = ["Jazeera Airways ", "J9"];
export const airline7C = ["Jeju Air", "7C"];
export const airlineB6 = ["JetBlue", "B6"];
export const airlineLJ = ["Jin Air", "LJ"];
export const airlineR5 = ["Jordan Aviatio", "R5"];
export const airlineHO = ["Juneyao Airlines", "HO"];
export const airlineRQ = ["Kam Air", "RQ"];
export const airlineKQ = ["Kenya Airways", "KQ"];
export const airlineKL = ["KLM", "KL"];
export const airlineKE = ["Korean Air", "KE"];
export const airlineKY = ["Kunming Airlines", "KY"];
export const airlineKU = ["Kuwait Airways", "KU"];
export const airlineTM = ["LAM", "TM"];
export const airlineQV = ["Lao Airlines", "QV"];
export const airlineJJ = ["LATAM Airlines Brasil", "JJ"];
export const airline4C = ["LATAM Airlines Colombia", "4C"];
export const airlineXL = ["LATAM Airlines Ecuador", "XL"];
export const airlineLA = ["LATAM Airlines Group", "LA"];
export const airlinePZ = ["LATAM Airlines Paraguay", "PZ"];
export const airlineLP = ["LATAM Airlines Peru", "LP"];
export const airlineM3 = ["LATAM Cargo Brasil", "M3"];
export const airlineUC = ["LATAM Cargo Chile", "UC"];
export const airlineGJ = ["Loong Air", "GJ"];
export const airlineLO = ["LOT Polish Airlines", "LO"];
export const airline8L = ["Lucky Air", "8L"];
export const airlineLH = ["Lufthansa", "LH"];
export const airlineCL = ["Lufthansa CityLine", "CL"];
export const airlineLG = ["Luxair", "LG"];
export const airlineMH = ["Malaysia Airlines", "MH"];
export const airlineAE = ["Mandarin Airlines", "AE"];
export const airlineMP = ["Martinair Cargo", "MP"];
export const airlineM7 = ["MasAir", "M7"];
export const airlineL6 = ["Mauritania Airlines International", "L6"];
export const airlineME = ["MEA", "ME"];
export const airlineOM = ["MIAT Mongolian Airlines", "OM"];
export const airlineMB = ["MNG Airlines", "MB"];
export const airline8M = ["Myanmar Airways International", "8M"];
export const airlineN8 = ["National Airlines", "N8"];
export const airlineKZ = ["NCA Nippon Cargo Airlines ", "KZ"];
export const airlineNO = ["Neos", "NO"];
export const airlineNE = ["Nesma Airlines", "NE"];
export const airlineNP = ["Nile Air", "NP"];
export const airlineY7 = ["NordStar", "Y7"];
export const airlineN4 = ["Nordwind Airlines", "N4"];
export const airlineBJ = ["Nouvelair", "BJ"];
export const airlineBK = ["Okay Airways", "BK"];
export const airlineOA = ["Olympic Air", "OA"];
export const airlineWY = ["Oman Air", "WY"];
export const airlineOF = ["Overland Airways", "OF"];
export const airlineZP = ["Paranair", "ZP"];
export const airlineEO = ["Pegas Fly", "EO"];
export const airlinePC = ["Pegasus Airlines", "PC"];
export const airlineNI = ["PGAPortugalia Airlines", "NI"];
export const airlinePR = ["Philippine Airlines", "PR"];
export const airlinePK = ["PIA Pakistan International Airlines", "PK"];
export const airlinePO = ["Polar Air Cargo", "PO"];
export const airlineM4 = ["Poste Air Cargo", "M4"];
export const airlinePW = ["Precision Air", "PW"];
export const airlineP6 = ["Privilege Style", "P6"];
export const airlineQF = ["Qantas", "QF"];
export const airlineQR = ["Qatar Airways", "QR"];
export const airlineIQ = ["Qazaq Air", "IQ"];
export const airline7H = ["Ravn Alaska", "7H"];
export const airlineFV = ["Rossiya Airlines ", "FV"];
export const airlineAT = ["Royal Air Maroc", "AT"];
export const airlineBI = ["Royal Brunei", "BI"];
export const airlineRJ = ["Royal Jordania", "RJ"];
export const airlineDR = ["Ruili Airlines", "DR"];
export const airline7R = ["RusLine", "7R"];
export const airlineWB = ["RwandAir", "WB"];
export const airlineS7 = ["S7 Airlines", "S7"];
export const airlineFA = ["Safair", "FA"];
export const airlineSK = ["SAS", "SK"];
export const airlineSP = ["SATA  Air Acores", "SP"];
export const airlineSV = ["Saudi Arabian Airlines", "SV"];
export const airlineDV = ["SCAT Airlines", "DV"];
export const airlineO3 = ["SF Airlines", "O3"];
export const airlineSC = ["Shandong Airlines ", "SC"];
export const airlineFM = ["Shanghai Airlines", "FM"];
export const airlineZH = ["Shenzhen Airlines ", "ZH"];
export const airline3U = ["Sichuan Airlines ", "3U"];
export const airline7L = ["Silk Way West Airlines", "7L"];
export const airlineSQ = ["Singapore Airlines", "SQ"];
export const airlineH2 = ["SKY Airline", "H2"];
export const airline5N = ["Smartavia", "5N"];
export const airlineQS = ["Smartwings", "QS"];
export const airlineIE = ["Solomon Airlines", "IE"];
export const airlineSZ = ["Somon Air", "SZ"];
export const airlineSA = ["South African Airways", "SA"];
export const airlineSG = ["SpiceJet", "SG"];
export const airlineUL = ["SriLankan Airlines", "UL"];
export const airlineXQ = ["SunExpress", "XQ"];
export const airlineY8 = ["Suparna Airlines", "Y8"];
export const airlineLX = ["SWISS", "LX"];
export const airlineRB = ["Syrianair", "RB"];
export const airlineTW = ["Tway Air", "TW"];
export const airlineDT = ["TAAG Angola Airlines", "DT"];
export const airlineTA = ["TACA", "TA"];
export const airlineTP = ["TAP Portugal", "TP"];
export const airlineRO = ["TAROM ", "RO"];
export const airlineSF = ["Tassili Airlines", "SF"];
export const airlineTG = ["Thai Airways International", "TG"];
export const airlineSL = ["Thai Lion Air", "SL"];
export const airlineWE = ["Thai Smile", "WE"];
export const airlineGS = ["Tianjin Airlines", "GS"];
export const airlineX3 = ["TUIfly", "X3"];
export const airlineTU = ["Tunisair", "TU"];
export const airlineTK = ["Turkish Airlines", "TK"];
export const airlinePS = ["Ukraine International Airlines", "PS"];
export const airlineB7 = ["UNI AIR", "B7"];
export const airlineUA = ["United Airlines", "UA"];
export const airline5X = ["UPS Airlines", "5X"];
export const airlineU6 = ["Ural Airlines", "U6"];
export const airlineUQ = ["Urumqi Air", "UQ"];
export const airlineUT = ["UTair", "UT"];
export const airlineHY = ["Uzbekistan Airways", "HY"];
export const airlineVJ = ["Vietjet", "VJ"];
export const airlineVN = ["Vietnam Airlines", "VN"];
export const airlineVS = ["Virgin Atlantic", "VS"];
export const airlineVA = ["Virgin Australia", "VA"];
export const airlineUK = ["Vistara", "UK"];
export const airlineY4 = ["Volaris", "Y4"];
export const airlineV7 = ["Volotea", "V7"];
export const airlineVY = ["Vueling", "VY"];
export const airlineEB = ["Wamos Air", "EB"];
export const airlinePN = ["West Air", "PN"];
export const airlineWS = ["WestJet", "WS"];
export const airlineWI = ["White coloured by you", "WI"];
export const airlineWF = ["Wideroe", "WF"];
export const airline2W = ["World2Fly", "2W"];
export const airlineMF = ["Xiamen Airlines", "MF"];
export const airlineYG = ["YTO Cargo Airlines", "YG"];
